<!-- <div class="content-with-filled-button">
    <h1 class="title" id="generalTitle">{{ titleOffice }}</h1>
    <span class="title" id="SpanTitle" *ngIf="subTitle"> {{ copyService.copies.city_offices_search_span_title }} </span>
    <div class="row">
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <vcl-alert class="errorSpan" type="error" [light]="true"
                *ngIf="!existOfficeByCity && selectedCity.city_code !== '0' || showEmptyOfficeError">
                {{ copyService.copies.city_offices_search_error__office_from_city_not_found_message }}
            </vcl-alert>
            <div class="box-input">
                <voxel-form-field [id]="'input_value_city'"
                    [label]="copyService.copies.city_offices_search_city_filter_city_label" [formGroup]="formGroup">
                    <vcl-autocomplete id="autoCompleteComponent"
                        [placeholder]="copyService.copies.city_offices_search_city_filter_city_placeholder"
                        (change)="selectOption($event)" required
                        [notFoundMessage]="copyService.copies.city_offices_search_city_filter_city_not_found_message"
                        [notFoundTitle]="copyService.copies.city_offices_search_city_filter_city_not_found_title"
                        (click)="pageTagEvent('3', eventCategories.TextField, 'click')">
                        <vcl-option [id]="'citySelection' + option.city_code" *ngFor="let option of options"
                            [value]="option"
                            [selected]="option.city_code === selectedCity.city_code && option.province_code === selectedCity.province_code">
                            {{ option.description }}
                        </vcl-option>
                    </vcl-autocomplete>
                </voxel-form-field>
            </div>
        </div>
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div class="box-input" *ngIf="existOfficeByCity">
                <voxel-form-field [id]="'input-value-office'"
                    [label]="copyService.copies.city_offices_search_city_filter_office_label" [formGroup]="formGroup">
                    <vcl-autocomplete id="autoCompleteComponent"
                        [placeholder]="copyService.copies.city_offices_search_city_filter_office_placeholder"
                        (change)="selectOptionOffice($event)" required
                        [notFoundTitle]="copyService.copies.city_offices_search_city_filter_office_not_found_title"
                        [notFoundMessage]="copyService.copies.city_offices_search_city_filter_office_not_found_message">
                        <vcl-option [id]="'citySelection' + optionOffice.agency_code"
                            *ngFor="let optionOffice of optionsOffice" [value]="optionOffice"
                            [selected]="selectedOffice.agency_code === optionOffice.agency_code">
                            {{ optionOffice.description }}
                        </vcl-option>
                    </vcl-autocomplete>
                </voxel-form-field>
            </div>
        </div>
    </div>
</div>
<app-controls id="residenceAbroadBtns" [hasPrevious]="true" [back]="back"
    [nextLabel]="copyService.copies.city_offices_search_city_next_button" (next)="next()"
    [nextDisabled]="showOptionsOffice"></app-controls> -->

<app-offices-search [isDisbursementOffice]="false" (officeSelectEventEmiter)="setAgency($event)"
 [titleOffice]="title" [subTitle]="true"></app-offices-search>